module.exports = "https://static.wagwalking.com/_next/static/images/book-pay-5b4bb7a4cc452077435edefd4b258983.svg";